
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import * as createBootstrap from 'bootstrap-vue-next';
import ToolTipDirective from './components/ToolTipDirective.js';
import repositories from './repositories/index';

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'

import "admin-lte/dist/css/adminlte.min.css";
import "admin-lte/dist/js/adminlte";
import "bootstrap/dist/js/bootstrap.bundle";

import "./scss/index";

import './assets/style.css'


const app  = createApp(App);


app.use(createBootstrap)
app.use(router)
app.use(repositories)

app.directive('tooltip', ToolTipDirective());
app.mount('#app')
